import chat from '../../images/slider/chat.svg'
import document2 from '../../images/slider/document2.svg'
import search2 from '../../images/slider/search2.svg'
import search from '../../images/slider/search.svg'
import moniter from '../../images/slider/moniter.svg'
import setting from '../../images/slider/setting.svg'
import lock from '../../images/slider/lock.svg'
import defense from '../../images/slider/defense.svg'
import message from '../../images/slider/message.svg'

const data = [[
  {
    img:moniter,
    title:'사내 시스템 내에서 임직원을<br/>클릭하면?채팅으로 바로 연결!',
    sub:"전자결재, 사내게시판 등 전사 시스템과 연동해 업무 진행 중 관련자와 커뮤니케이션이 필요한 순간, 즉각적으로 채팅 전환"
  },
  {
    img:setting,
    title:"채팅 목록 세분화로<br/>상황 별 필요한 채팅을 한 눈에",
    sub:"채팅 목록이 전체, 문서, 사용자 총 3가지로 분류돼 있어 업무 과정에서 필요에 따른 채팅 목록을 손쉽게 구분 및 확인 가능"
  },
  {
    img:search,
    title:"누구나 빠르게 활용 가능한<br/>사용자 중심 환경",
    sub:"전체적으로 사용자 입장에서 익숙한 채팅 UI/UX 구조를 차용해 클릭, 스와이프 동작을 통한 직관적인 이용 가능"
  }],
  [
    {
      img:chat,
      title:"협업 콘텐츠<br/>기반 채팅",
      sub:"협업 콘텐츠를 기준으로 해당 파일의 권한을 가진 인원들로만 구성된 채팅방이 자동으로 생성돼 효율적인 커뮤니케이션 실현"
    },    
    {
      img:document2,
      title:"협업 콘텐츠<br/>파편화 방지",
      sub:"사내 시스템 내 최신 버전의 문서 목록을 메신저에서도 쉽고 일관적으로 관리할 수 있어 협업 콘텐츠의 정보 파편화를 방지"
    },
    {
      img:search2,
      title:"메신저에서도<br/>통합 문서 검색",
      sub:"커뮤니케이션을 진행하던 문서를 메신저 내 통합 검색 기능을 통해 손쉽게 탐색 후 지속적인 협업 가능"
    }
  ],
  [
    {
      img:lock,
      title:"데이터<br/>암호화는 기본",
      sub:"메시지 및 파일 데이터를 자체 암호화해 주고 받는 전체 협업 콘텐츠의 안전한 상태를 언제나 유지"
    },    
    {
      img:defense,
      title:"어떤 파일이든지<br/>중요성에 맞게 보호",
      sub:"문서, PPT, 일러스트, 도면 등 파일 종류 상관없이 요구되는 보안 수준에 따라 정책을 적용해 세분화된 권한 부여 및 관리 가능"
    },
    {
      img:message,
      title:"One-Click<br/>메시지 초기화",
      sub:"단 한번의 클릭으로 민감 내용이 포함된 채팅방의 메시지를 초기화해 효과적인 컴플라이언스 대응이 가능한 철통보안 서비스"
    }
  ]
]

export default data;